/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'accountType': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'companyName': string;
}

export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum];


